import React from "react";
import FullscreenLoader from "../../components/Authentication/FullscreenLoader";

export const CallbackPage = () => {
    return (
        <div className="page-layout">
            <FullscreenLoader/>
        </div>
    );
};